/**
 * Axios Util
 *
 * REFERENCIA: https://github.com/axios/axios
 * 
 * @author lgmcjr@celepar.pr.gov.br
 * @since 30/08/2022
 */
import axios from 'axios'

// axios.defaults.withCredentials = true

const _axios = axios.create({
  withCredentials: true
})

/*
_axios.interceptors.request.use(function (request) {
  return request
},
function (error) {
  return Promise.reject(error)
})
*/

export default _axios